<template>
  <div>
    <div>
      <div class="filter">
        <h3 class="mb-2">코드 상세</h3>
        <div class="filter-box filter-box--row">
          <ul class="filter-list02">
            <li>
              <h4>공통코드명</h4>
              <v-text-field outlined dense filled disabled :value="this.data.gubun"></v-text-field>
            </li>
            <li>
              <h4>코드</h4>
              <v-text-field outlined dense filled disabled :value="this.data.code"></v-text-field>
            </li>
          </ul>
        </div>
      </div>
      <h3 class="mt-4">상세 정보</h3>
      <div class="wrapperEnd mb-2">
        <v-btn depressed class="btn-add mr-1" @click="addNewRow">항목 추가</v-btn>
        <v-btn depressed class="btn-save" @click="saveData">저장</v-btn>
      </div>
      <RealGrid :domName="grid" ref="grid" :settings="settings" @changePage="loadData" />
    </div>
    <SetPopup ref="confirm" />
  </div>
</template>
<script>
import { getCodeDetail, insertCode, updateCode } from 'api/common';
import { mapMutations } from 'vuex';
import { columns, fields, rows, height, noneNo } from '@/assets/grid/codeMgnDetail';
import { errorText } from '@/assets/apiError';
import RealGrid from '@/components/RealGrid.vue';
import SetPopup from '@/components/SetPopup.vue';
import _ from 'lodash';
export default {
  props: ['data'],
  watch: {
    'this.data': {
      deep: true,
      handelr: function () {},
    },
  },
  data() {
    return {
      settings: {
        // 값, 설명, 사용여부를 편집한다. 항목 번호는 조회할 때 매기는 표시용이다.
        columns: _.map(_.cloneDeep(columns), function (v) {
          if (v.fieldName === 'val' || v.fieldName === 'description') {
            v.editable = true;
          }
          if (v.fieldName === 'use_yn') {
            v.editable = true;
            v.editor = {
              type: 'dropdown',
              textReadOnly: true,
              domainOnly: true,
              dropDownWhenClick: true,
            };
            v.values = ['Y', 'N'];
            v.labels = ['Y', 'N'];
            v.lookupDisplay = true;
          }
          return v;
        }),
        fields,
        rows,
        height,
        noneNo,
        errorMessage: '잘못된 접근입니다',
        hideCheckBar: false,
      },
      grid: 'codeDetai',
      currentPage: 1,
      pageSize: 15,
      saveParam: {},
      isSaving: false,
    };
  },
  computed: {},
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapMutations('common', ['SET_CODE']),
    ...mapMutations('popup', ['SET_POPUP']),
    // 관리 화면이라 미사용(N) 항목까지 받아 온다.
    async loadData() {
      const res = await getCodeDetail(this.data.code);
      const data = res.data.data;
      _.each(data, (v, i) => {
        v.index = `항목${i + 1}`;
      });
      this.$refs.grid.loadData(data);
    },
    // 신규 항목은 순번이 비어 있다. 저장할 때 등록과 수정을 이걸로 가른다.
    addNewRow() {
      const rowCount = this.$refs.grid.getJsonRows().length;
      this.$refs.grid.addRow({
        idx: '',
        index: `항목${rowCount + 1}`,
        val: '',
        description: '',
        use_yn: 'Y',
      });
    },
    async saveData() {
      if (this.isSaving) return;

      this.$refs.grid.commitGridEditor();

      const checkedRows = this.$refs.grid.gv.getCheckedRows(true, false, false);
      if (checkedRows.length === 0) {
        this.openPopup('저장할 항목을 선택해 주세요.');
        return;
      }

      const allData = this.$refs.grid.getJsonRows();
      this.isSaving = true;

      try {
        for (const rowIndex of checkedRows) {
          const row = allData[rowIndex];
          // 공통코드명과 코드는 이 화면에서 바꾸지 않는다. 상위에서 받은 값을 그대로 쓴다.
          const param = {
            gubun: this.data.gubun,
            code: this.data.code,
            val: row.val,
            description: row.description,
            useYn: row.use_yn,
          };

          if (row.idx == null || row.idx === '') {
            await insertCode(param);
          } else {
            await updateCode({ ...param, idx: row.idx });
          }
        }

        await this.loadData();
        // 드롭다운이 들고 있는 공통코드를 새로 받아 온다.
        this.SET_CODE(this.data.code);
        this.openPopup('저장되었습니다.');
      } catch (err) {
        this.openPopup(errorText(err, '저장에 실패했습니다.'));
      } finally {
        this.isSaving = false;
      }
    },
    openPopup(text, closable = false, cb) {
      this.SET_POPUP({
        title: '알림',
        width: 300,
        closable: closable,
        text: text,
      });
      this.$refs.confirm.openPopup(cb);
    },
  },
  components: {
    RealGrid,
    SetPopup,
  },
};
</script>
<style>
.login .v-input__slot {
  width: 100% !important;
}
</style>
